import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import './fontawesome';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

// Create a root.
const root = ReactDOMClient.createRoot(container);

// Initial render: Render an element to the root.
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
